import { render } from "./header.vue?vue&type=template&id=5b5b74f3"
const script = {}

import exportComponent from "D:\\tlpwork\\artandmewebsiet\\artandmewebsiet\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__